export default __webpack_public_path__ + "static/media/RC_Logo_White.fae7d5cb.svg";